/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

import { positionChangeWidthSm, navbarHeight, footerHeight, scorecardPointsObj, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, bumbleProfilePromptTextColor, hingeProfileBackgroundColor, hingeProfileImageDimension, hingeProfileItemBorderColor, hingeProfileItemBorderRadius, hingeProfileItemBorderWidth, hingeProfileItemBoxShadow, hingeProfileItemDividerOpacity, tinderImageHeight, tinderLeadImageHeight, tinderProfileBackgroundColor, tinderProfileImageIndicatorWidth, tinderProfileImageWidth, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileItemBorderRadius, tinderProfileItemBorderWidth, tinderProfileItemBoxShadow, tinderProfileItemDividerOpacity, tinderProfilePromptTextColor, tinderProfileTextColor, swipelyticsTurquoise, profPicDefaultURL, swipelyticsPink } from '../../../helpers/variableDefaults'
import { standardInfoTooltip } from '../../../helpers/tooltips'
import { mediaScore, bioScore, promptsScore, aboutMeScore, vitalInfoScore, totalScore, totalGrade, totalGradeColor } from '../../../helpers/commonMethods'

export const viewFeedbackScorecardJSX = (profileType, mediaFeedbackArray, bioFeedbackObj, clientVitalInfo, width) => {
  

  const scorecardElementJSX = (title, score) => {
    return (
      <Box
        sx={{
          color: profileType === 'tinder' ? 'black' : 'white',
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {/* Divider */}
        {title !== 'Media' &&
          <Divider sx={{ width: '100%', my: 0, borderColor: profileType === 'tinder' ? 'black' : 'white' }} orientation="horizontal" />
        }

        {/* Scorecard Element */}
        <Box
          sx={{
            py: 2, px: 2,
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
          }}
        >
          {/* Title */}
          <Box
            sx={{
              fontWeight: title === 'Total' ? 900 : 'normal',
              fontSize: title === 'Total' ? '18px' : '16px',
            }}
          >
            {title} Score:
          </Box>

          {/* Score */}
          <Box
            sx={{
              fontWeight: title === 'Total' ? 900 : 'normal',
              fontSize: title === 'Total' ? '18px' : '16px',
            }}
          >
            {score}
          </Box>
        </Box>
      </Box>
    )
  } 
  
  return (
    <Box
      sx={{
        mt: 2, py: 2,
        width: profileType === 'bumble' ? bumbleProfileImageWidth(width) : profileType === 'tinder' ? tinderProfileImageWidth(width) : profileType === 'hinge' ? hingeProfileImageDimension(width) : hingeProfileImageDimension(width),
        // backgroundColor: 'mistyrose',
        backgroundColor: profileType === 'tinder' ? 'whitesmoke' : 'black',
        // backgroundColor: 'lightyellow',
        border: profileType === 'bumble' ? bumbleProfileItemBorderWidth : profileType === 'tinder' ? tinderProfileItemBorderWidth : profileType === 'hinge' ? hingeProfileItemBorderWidth : hingeProfileItemBorderWidth,
        borderColor: profileType === 'bumble' ? bumbleProfileItemBorderColor : profileType === 'tinder' ? tinderProfileItemBorderColor : profileType === 'hinge' ? hingeProfileItemBorderColor : hingeProfileItemBorderColor,
        boxShadow: profileType === 'bumble' ? bumbleProfileItemBoxShadow : profileType === 'tinder' ? tinderProfileItemBoxShadow : profileType === 'hinge' ? hingeProfileItemBoxShadow : hingeProfileItemBoxShadow, 
        borderRadius: profileType === 'bumble' ? bumbleProfileItemBorderRadius : profileType === 'tinder' ? tinderProfileItemBorderRadius : profileType === 'hinge' ? hingeProfileItemBorderRadius : hingeProfileItemBorderRadius,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >

      {/* Title */}
      <Box
        sx={{
          width: '100%',
          fontSize: '18px',
          fontWeight: 'bold',
          color: profileType === 'tinder' ? 'black' : 'white',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
        }}
      >
        Scorecard
      </Box>

      {/* Media */}
      {scorecardElementJSX(`Media`, mediaScore(mediaFeedbackArray))}

      {/* Prompts */}
      {scorecardElementJSX(`Prompts`, promptsScore(bioFeedbackObj))}

      {/* About Me */}
      {profileType !== 'hinge' && scorecardElementJSX(`About Me`, aboutMeScore(profileType, bioFeedbackObj))}

      {/* Vital Info */}
      {scorecardElementJSX(`Vital Info`, vitalInfoScore(bioFeedbackObj))}

      {/* Bio */}
      {/* {scorecardElementJSX(`Bio`, bioScore(profileType, bioFeedbackObj))} */}

      {/* Total */}
      {scorecardElementJSX(`Total`, totalScore(profileType, mediaFeedbackArray, bioFeedbackObj))}

      {/* Overall Verdict */}
      <Box
        sx={{
          my: 1.5,
          width: '100%',
          fontSize: '20px',
          fontWeight: 900,
          // color: totalGrade(totalScore(profileType, mediaFeedbackArray, bioFeedbackObj)).toLowerCase() === 'needs work' ? swipelyticsPink : totalGrade(totalScore(profileType, mediaFeedbackArray, bioFeedbackObj)).toLowerCase() === 'passable' ? 'lightblue' : swipelyticsTurquoise,
          color: totalGradeColor('scorecard', totalGrade(totalScore(profileType, mediaFeedbackArray, bioFeedbackObj))),
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {totalGrade(totalScore(profileType, mediaFeedbackArray, bioFeedbackObj))}
      </Box>

      {/* Info Tooltip */}
      <Box
        sx={{
          mt: 1,
          mb: 2,
          width: '100%',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {standardInfoTooltip(
          `
            <p><span style="font-weight:bold; color:white;">15+ = Elite</span></p>
            <p><span style="font-weight:bold; color:white;">10+ = Very Good</span></p>
            <p><span style="font-weight:bold; color:white;">5+ = Good</span></p>
            <p><span style="font-weight:bold; color:white;">1+ = Passable</span></p>
            <p><span style="font-weight:bold; color:white;">0- = Needs Work</span></p>
          `,
          0,
          profileType === 'tinder' ? 'black' : 'white'
        )}
      </Box>

    </Box>
  )
}